import React from 'react'
import {  Box, Tooltip} from '@mui/material'
import { gql, useQuery } from '@apollo/client'
import TableView, { useTable } from 'packages/ui/Table'
import { useTranslation } from 'react-i18next'

const OPERATION_SPEEDTEST = gql`
  query GetSiteSpeedtest(
    $sf_id: String
  ) {
    site: findSite(sf_id: $sf_id) {
      speedtest_paginate {
        next_page
        results {
          download_bits_by_sec
          upload_bits_by_sec
          latency
          launched_at
        }
      }
    }
  }
`

const COLUMNS_CONFIG = [
  {
    name: 'launched_at',
    header: {
      label: ctx => ctx.t('supervision.card.speedtest.launched_at')
    },
    value: ({ launched_at }) => (
      <Tooltip
        title={new Date(launched_at).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})}
        arrow
        placement={'top'}>
        {new Date(launched_at).toLocaleDateString()}
      </Tooltip>
    )
  },
  {
    name: 'download_bits_by_sec',
    header: {
      label: ctx => ctx.t('supervision.card.speedtest.download')
    },
    value: ({ download_bits_by_sec }) => `${Number.parseFloat(download_bits_by_sec / 1000000).toFixed(1)} Mbps`,
  },
  {
    name: 'upload_bits_by_sec',
    header: {
      label: ctx => ctx.t('supervision.card.speedtest.upload')
    },
    value: ({ upload_bits_by_sec }) => `${Number.parseFloat(upload_bits_by_sec / 1000000).toFixed(1)} Mbps`,
  },
  {
    name: 'latency',
    header: {
      label: ctx => ctx.t('supervision.card.speedtest.latency')
    },
    value: ({ latency }) => `${latency} ms`
  }
]
const Speedtest = ({site}) => {
  const {t} = useTranslation()
  const {loading, data} = useQuery(OPERATION_SPEEDTEST, {
    variables: {
      sf_id: site.sf_id,
    }
  })
  const apiTable = useTable({
    rowKey: 'sf_id',
    items: data?.site?.speedtest_paginate?.results || [],
    loading,
    columns: COLUMNS_CONFIG
  })
  return (
    <Box
      sx={{
        height: '200px',
        overflow: 'auto',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
          display: 'none'
        }
      }}
    >
      <TableView
        apiTable={apiTable}
        view={'card'}
        noItemsMessage={t('supervision.card.speedtest.no_items')}
      />
    </Box>
  )
}
export default Speedtest
